var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"type":_vm.type,"color":_vm.color},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_c('p',{staticClass:"alert"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }